module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNjAgNjAiPjxzdHlsZT4uc3Qwe2ZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO2ZpbGw6I0Y1RjdGODt9PC9zdHlsZT48ZyBpZD0iWE1MSURfMzhfIj48cGF0aCBpZD0iWE1MSURfMzlfIiBjbGFzcz0ic3QwIiBkPSJNMzAgMEMxMy40IDAgMCAxMy40IDAgMzBzMTMuNCAzMCAzMCAzMCAzMC0xMy40IDMwLTMwUzQ2LjYgMCAzMCAwem0wIDU3LjVDMTQuOCA1Ny41IDIuNSA0NS4yIDIuNSAzMFMxNC44IDIuNSAzMCAyLjUgNTcuNSAxNC44IDU3LjUgMzAgNDUuMiA1Ny41IDMwIDU3LjV6bS0xLjQtMjQuMXYxMS4xbDExLjktMjMtMjMgMTEuOWgxMS4xeiIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/images/services-icon.svg
// module id = 591
// module chunks = 54681204059826